import get from 'lodash.get'

export const STATES = {
  default: 'Bestilt',
  awaiting_approval: 'Til godkjenning',
  lacking_input: 'Venter på underlag',
  cancelled: 'Kansellert',
  booked: 'Booket',
  production_in_progress: 'Under produksjon',
  waiting_for_input: 'Avventer underlag',
  delivered: 'Levert',
  partially_delivered: 'Delvis levert',
  ordered: 'Bestilt',
  marked_for_correction: 'Til korreksjon',

  // Product specific overrides
  VideoProduct: {
    lacking_input: 'Velg rom og tekst',
  },
  CollageProduct: {
    lacking_input: 'Velg bilder',
  },
  RetouchedEveningPhotoProduct: {
    lacking_input: 'Velg bilder',
  },
  DigitalRetouchedFurnishingPhotoProduct: {
    lacking_input: 'Velg bilder',
  },
  DigitalRetouchedRenovationPhotoProduct: {
    lacking_input: 'Velg bilder',
  },
  SlideshowProduct: {
    lacking_input: 'Velg bilder',
  }
}

export function translateProductState(product) {
  let state = product.state

  if (product.canProvideUserInput) {
    state = 'lacking_input'
  }

  const productSpecificPath = product.__typename
    ? `${product.__typename}.${state}`
    : state

  return get(STATES, productSpecificPath) || STATES[state] || STATES.default
}
